import { render, staticRenderFns } from "./ArticlePriceTable.vue?vue&type=template&id=1ddffcef&scoped=true"
import script from "./ArticlePriceTable.vue?vue&type=script&lang=js"
export * from "./ArticlePriceTable.vue?vue&type=script&lang=js"
import style0 from "./ArticlePriceTable.vue?vue&type=style&index=0&id=1ddffcef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddffcef",
  null
  
)

export default component.exports